import React from 'react'
import { CollectionTable } from '..'

const Works = props => <CollectionTable type="work" history={props.history} />

export default Works
